import { Link } from "react-router-dom";
import localeText from "../../../../locale";

const FooterColumn = ({ heading, links, id }) => {
  const capitalizeFirst = (text) => {
    if (!text) return text;
    return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
  };

  return (
    <>
      <div className="text-md font-bold mb-3" style={{ color: "#fff" }}>
        {heading}
      </div>
      <div className="flex flex-column gap-3">
        {links.map((link) =>
          link.url.startsWith("/") ? (
            <Link
              to={link.url}
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              key={`link-${id}-${link.id}`}
              className="text-sm font-medium"
              style={{ color: "#DCEFE3" }}
            >
              {link.applyCapitalize ? capitalizeFirst(link.text) : link.text}
            </Link>
          ) : (
            <a
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              key={`link-${id}-${link.id}`}
              className="text-sm font-medium"
              style={{ color: "#DCEFE3" }}
            >
              {link.applyCapitalize ? capitalizeFirst(link.text) : link.text}
            </a>
          )
        )}
      </div>
    </>
  );
};
const LandingFooterLinks = () => {
  const footerColumns = [
    {
      heading: "Extraconomy",
      links: [
        { text: localeText("lp2LinkDescubra"), url: "/sobre", id: 10 },
        { text: localeText("lp2LinkEmpresas"), url: "/empresas", id: 11 },
        { text: localeText("lp2LinkTecnologia"), url: "/white-label", id: 12 },
        { text: "Federnet", url: "https://www.federnet.it/", id: 13 },
        { text: "Extracoin", url: "https://extracoin.site/", id: 15 },
        { text: localeText("lp2LinkAjuda"), url: "https://wa.me/+393517670019", id: 16 },
      ],
      id: 1,
    },
    {
      heading: localeText("lp2FooterColPerfis"),
      links: [
        { text: localeText("lp2LinkPerfisPlanos"), url: "/planos", id: 20 },
        { text: "Customer", url: "/customer", id: 21 },
        { text: "Partner", url: "/partner", id: 22 },
        { text: "Seller", url: "/sellerprofile", id: 23 },
        { text: "Manager", url: "/manager", id: 24 },
        { text: "Store", url: "/storeprofile", id: 25 },
      ],
      id: 2,
    },
    {
      heading: localeText("lp2FooterColGanheDinheiro"),
      links: [
        { text: localeText("toTheStore"), url: "/shop", id: 30, applyCapitalize: true },
        { text: localeText("lp2LinkSejaPromotor"), url: "/promoter", id: 31 }
      ],
      id: 3,
    },
    {
      heading: localeText("lp2FooterColPoliticas"),
      links: [
        { text: localeText("lp2LinkPrivacidade"), url: "/privacy", id: 40 },
        { text: localeText("lp2LinkTermos"), url: "/privacy", id: 41 },
      ],
      id: 4,
    },
  ];
  return (
    <>
      {footerColumns.map((column) => (
        <div key={column.id} className="flex flex-column gap-3 col-12 sm:col-6 lg:col">
          <FooterColumn id={column.id} heading={column.heading} links={column.links} />
        </div>
      ))}
    </>
  );
};
export default LandingFooterLinks;
